import React, { Component } from 'react';
import { jsxWith } from '../utils/jsx.util';

// TODO: move this into rep_card_component

export default class NMRepPhoneNumber extends Component {
  render() {
    return jsxWith(this.props.phoneNumber, phoneNumber => (
      <a
        href={`tel:${phoneNumber
          .replace('(', '')
          .replace(')', '')
          .replace('-', '') // TODO: come back and fix: shouldn't have to repeat this dash replace for second dash
          .replace(' ', '')
          .replace('-', '')}`}
        className='fr-phone url'>
        <span className='value tel'>{phoneNumber}</span>
      </a>
    ));
  }
}
